import { createSelector } from 'reselect'

export const selectLocationsDomain = state => state.get('locations').toJS()
export const selectLocationsLoading = () => createSelector(selectLocationsDomain, state => state.loading)
export const selectLocationsData = () => createSelector(selectLocationsDomain, state => state.data)
export const selectLocationsStates = () => createSelector(selectLocationsDomain, state => state.states)
export const selectLocationsCities = () => createSelector(selectLocationsDomain, state => state.cities)
